// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".twitter-cropper{height:521px}.twitter-cropper__background{background-color:#f7f7f7}.twitter-cropper__foreground{background-color:hsla(0,0%,67.5%,.796078431372549)}.twitter-cropper__stencil{border:1px solid #3c2cb1}", ""]);
// Exports
module.exports = exports;
